<template>
	<div class="container-lg container-fluid g-0">
		<div class="row g-0">
			<div class="col-xs-12 g-0">
			        <input class="form-control" id="search-input" type="search" aria-label="Search" v-model="searchQuery" placeholder="Search...">
			</div>
		</div>
		<div class="row g-0">
			<div class="col-xs-12 g-0">
				<q-table 
	
			        	id="line-list"
			        	class="table table-striped table-bordered table-hover"
			        	:data="buylistLines"
			        	:columns="buylistColumns"
			        	row-key="id"
			        	virtual-scroll
			        	:virtual-scroll-item-size="30"
			        	:virtual-scroll-sticky-size-start="30"
			        	:pagination.sync="pagination"
			        	:filter="searchQuery"
						:sort-method="resortLines"
						binary-state-sort
						hide-bottom
					    selection="single"
					    :selected.sync="selected"
						ref="buyListLinesRef" v-cloak
						scroll-target="body"
			        >
			        <template v-slot:body="item">
						<q-tr>
							<q-td></q-td>
							<template v-for="column in visibleColumns">
							    <q-td v-if="buylistColumnMap[column].datatype != 'notes'">
							   		 {{item.row[column]}}
							    </q-td>		
							    <q-td v-if="buylistColumnMap[column].datatype=='notes'">
							   		 <input type="text" class="form-control" :data-col='column' v-model="item.row[column]" @focus="selectText"  @blur="processUpdate(item.row)">
							   		 <span class="invisible extender">{{item.row[column]}}</span>
							    </q-td>				    					    
							</template>
						</q-tr>			     
			        </template>
				</q-table>
			</div>
		</div>
	</div>
</template>
<script>
import { Modal } from 'bootstrap';
import Vue from 'vue';
import Vuex from 'vuex';
import accounting from 'accounting';
import XLSX from 'xlsx';
import { 
  QTable,
  QTh,
  QTr,
  QTd,
  QLinearProgress
} from 'quasar';

import Quasar  from 'quasar';

import debounce from 'debounce';

import VueAutosuggest from "vue-autosuggest";
Vue.use(VueAutosuggest);

import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 3
});




Vue.use(Vuex);
Vue.use(Quasar);

var buylistSearch = {
	data() {
		return {
			searchQuery: "",
			buylistLines: [],
		    pagination: {
		        rowsPerPage: 0
		    },
		    selected: [],
			buylistColumns: [{
				'name' : 'description',
				'field' : 'description',
				'datatype' : 'string',
				'align' : 'center',
				'label' : 'Item',
				'sortable' : true
			},{
				'name' : 'max_tax_out',
				'field' : 'max_tax_out',
				'datatype' : 'yen',
				'align' : 'center',
				'label' : 'Max Cost',
				'sortable' : true
			},{
				'name' : 'style_number',
				'field' : 'style_number',
				'datatype' : 'string',
				'align' : 'center',
				'label' : 'Style',
				'sortable' : true
			},{
				'name' : 'notes',
				'field' : 'notes',
				'datatype' : 'notes',
				'align' : 'center',
				'label' : 'Notes',
				'sortable' : true
			}],
			buylistColumnMap: {
				'description' : {
					'name' : 'description',
					'field' : 'description',
					'datatype' : 'string',
					'align' : 'center',
					'label' : 'Item',
					'sortable' : true
				},
				'max_tax_out' : {
					'name' : 'max_tax_out',
					'field' : 'max_tax_out',
					'datatype' : 'yen',
					'align' : 'center',
					'label' : 'Max Cost',
					'sortable' : true
				},
				'style_number' : {
					'name' : 'style_number',
					'field' : 'style_number',
					'datatype' : 'string',
					'align' : 'center',
					'label' : 'Style',
					'sortable' : true
				},
				'notes' : {
					'name' : 'notes',
					'field' : 'notes',
					'datatype' : 'notes',
					'align' : 'center',
					'label' : 'Notes',
					'sortable' : true
				}
			},
			visibleColumns: [
				'description','max_tax_out','style_number','notes'
			]
		}
	},
	props: {
		
	},
	mounted() {
		this.populateBuylist();
		document.getElementById("search-input").focus();
	},
	watch: {
		pagination: {
			handler: function (n, o) {
				this.buylistLines = this.realResortLines(this.buylistLines, n.sortBy, n.descending);
			},
			deep: true
		}
	},
	name: 'BuylistSearch',
	methods: {
		resortLines(rows, sortBy, descending) {
			// this is a dummy function.  the real sorting happens only when the pagination prop is updated - see watcher below.
			// We do this so rows do not resort while people are typing - rows only resort when users actually change the sort option
			// This more closely mirrors the excel behavior
			return rows;
		},
	    realResortLines(rows, sortBy, descending) {
		    // this is the actual resort function
		    const data = [ ...rows ], sortDirection = (descending) ? "up" : "down", sortField = sortBy, self = this;
		    	    	
		    let buylistLines = this.buylistLines;
		    const numericSorts = ["number", "usd","yen"];
	    	data.sort((a,b) => {
		    	if (a === null || a[sortField] === undefined) {
			    	a = "";
			    } else if (numericSorts.indexOf(self.buylistColumnMap[sortField].datatype) > -1) {
				    a = accounting.unformat(a[sortField]);
			    } else if (isNaN(a[sortField])) {
				    a =  a[sortField].toString().toLowerCase().trim();
				} else {
				    a =  a[sortField];
				}
		    	if (a === null) a = "";
		    	
		    	if (b === null || b[sortField] === undefined) {
			    	b = "";
			    } else if (numericSorts.indexOf(self.buylistColumnMap[sortField].datatype) > -1) {
				    b = accounting.unformat(b[sortField]);
			    } else if (isNaN(b[sortField])) {
				    b =  b[sortField].toString().toLowerCase().trim();
			    } else {
				    b =  b[sortField];
				}
		    	if (b === null) b = "";
		    	
		    	if (a > b) return ((sortDirection == "up") ? -1 : 1);
		    	if (b > a) return ((sortDirection == "up") ? 1 : -1);
		    	return 0;
	    	});
	    	
	    	return data;
		    
	    },
	    formatNumeric(row, remove) {
		    if (!row) return;
		    this.buylistColumns.forEach(col => {
			   if (row[col.name] == undefined) return;
			   if (['usd','yen'].indexOf(col.datatype) == -1) return;
			   if (remove) {
				  row[col.name] = accounting.unformat(row[col.name]);
				  return;
			   }
			   if (col.datatype == "usd") {
				   row[col.name] = accounting.formatMoney(row[col.name]);
			   }
			   if (col.datatype == "yen") {
				   row[col.name] = accounting.formatMoney(row[col.name], "¥", 2);
			   }
		    });
		    return row;
	    },
        async populateBuylist() {
        	var response = await axios.get('/styles'), self = this;
        	response.data.forEach((l) => {
				l = self.formatNumeric(l);
		
		    });

        	this.buylistLines = response.data;
        	this.pagination.descending = true;
        	this.pagination.sortBy = 'notes';
        },
		selectText(e) {
			e.target.setSelectionRange(0, e.target.value.length);
		},
		async processUpdate(row) {
			const data = {
				'product_id' : row.id,
				'note' : row.notes
			}
            axios.post('/note', data);
		}
	}
};

export default buylistSearch;

</script>
<style>
  @import '/css/buylist_search.css';
</style>